import { types } from 'mobx-state-tree';

import { getValueFromLocalStorage } from '../../utilities/utilityFunctions';

export const SiteDiscipline = types
  .model({
    site: types.maybeNull(types.string),
    discipline: types.maybeNull(types.string),
    wpCount: types.maybeNull(types.number),
    refreshWorkPackage: types.boolean,
    siteId: types.number,
    disciplineId: types.number,
    siteDisciplineUpdateInitialSync: types.boolean,
  })
  .views(self => ({
    get getSiteDisciplineData() {
      return {
        site: self.site,
        discipline: self.discipline,
        wpCount: self.wpCount,
      };
    },
  }))
  .actions(self => ({
    setSiteDisciplineData: () => {
      const selectedSite = JSON.parse(getValueFromLocalStorage('selectedSite'));
      const selectedDiscipline = JSON.parse(getValueFromLocalStorage('selectedDiscipline'));
      self.site = selectedSite?.selectedSite;
      self.discipline = selectedDiscipline?.selectedDiscipline;
      self.siteId = selectedSite?.selectedSiteId;
      self.disciplineId = selectedDiscipline?.selectedDisciplineId;
    },
    setDiscipline: (discipline: { selectedDiscipline: string; selectedDisciplineId: number }) => {
      self.discipline = discipline.selectedDiscipline;
    },
    setWpCount: (count: number) => {
      self.wpCount = count;
    },
    setRefreshWorkPackage: (value: boolean) => {
      self.refreshWorkPackage = value;
    },
    setSiteDisciplineUpdateInitialSync: (flag: boolean) => {
      self.siteDisciplineUpdateInitialSync = flag;
    },
  }));

export default SiteDiscipline;
